import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { alertSuccess, alertServerError, alertError } from "../../../helpers/alertError";
import PageLayout from "../../../layouts/PageLayout";
import PageContainer from "../../../components/ui/PageContainer";
import { productService, uploadService } from "@cabukaka/services";
import ProductForm from "../../../components/features/products/ProductForm";
import { useAuth, useCategories, useToken } from "@cabukaka/hooks";
import { BaseVariant, ProductFormData } from "@cabukaka/types";

export default function NewProductPage() {
    const navigate = useNavigate();
    const [isLoading, setIsLoading] = useState(false);
    const { token } = useToken();
    const { categories } = useCategories();
    const { user } = useAuth();

    const handleSubmit = async (formData: ProductFormData) => {
        setIsLoading(true);
        if (!token) {
            alertError("Une erreur s'est produite");
            setIsLoading(false);
            return;
        }

        try {
            // Upload des images du produit
            const productImages = await uploadService.uploadMultiple(formData.localImages, token);

            // Upload des images des variantes
            let variantsWithImages: BaseVariant[] | undefined;
            if (formData.variantsFormData && formData.variantsFormData.length > 0) {
                variantsWithImages = await Promise.all(
                    formData.variantsFormData.map(async (variant) => {
                        let variantImages: string[] = [];
                        if (variant.localImages && variant.localImages.length > 0) {
                            variantImages = await uploadService.uploadMultiple(variant.localImages, token);
                        }
                        return {
                            name: variant.name,
                            value: variant.value,
                            originalPrice: variant.originalPrice,
                            price: variant.price,
                            description: variant.description,
                            stock: variant.stock,
                            images: variantImages
                        };
                    })
                );
            }

            const submitData = {
                name: formData.name,
                description: formData.description,
                priceMode: formData.priceMode,
                unit: formData.unit,
                categoryId: formData.categoryId,
                subcategoryId: formData.subcategoryId,
                originalPrice: formData.originalPrice,
                price: formData.price,
                inStock: formData.inStock,
                stock: formData.stock,
                images: productImages,
                shopId: user?.profile?.id,
                baseVariants: variantsWithImages
            };

            await productService.baseService.create(submitData, token);
            alertSuccess("Produit créé avec succès");
            navigate(-1);
        } catch (error: any) {
            console.error(error);
            alertServerError(error);
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <PageLayout title="Nouveau produit">
            <PageContainer>
                <ProductForm
                
                    categories={categories}
                    onSubmit={handleSubmit}
                    isSubmitting={isLoading}
                />
            </PageContainer>
        </PageLayout>
    );
}